module.exports = __webpack_public_path__ + "static/media/woods.25bec312.jpg";